<template>
  <div>
    <div style="text-align:left">
      结果:{{scanQRCodeValue}}<br />
    </div>
  </div>
</template>
<script>
 import { GetQueryString } from '@/assets/js/common.js'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      scanQRCodeValue: "",
    };
  },
  methods: {
    scanQRCode() {
      let _this = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          _this.scanQRCodeValue = res.resultStr;
          console.log("扫描结果为：" + res.resultStr);
        }
      });
    },
    detectAuth() {
      this.$postQuery('/tencentFaceId/detectAuth', null).then((response) => {
        console.log(response);
        window.location.href=response.obj.url;
      })
    }
  },
  created: function () {
    console.log("-----------href--------------");
    console.log(window.location.href)
    let BizToken = GetQueryString("BizToken");
    let data = {
      faceIdToken: BizToken
    }
    this.$postQuery('/tencentFaceId/getDetectInfo', data).then((response) => {
        console.log(response);
        this.scanQRCodeValue=JSON.stringify(response);
    })
  }
};
</script>>